// src/i18n/en/labels.ts
// Reusable labels (catalog + device assignment)

const labels = {
  deviceCard: {
    title: 'Labels',
    subtitle: 'Classify the device with reusable labels, independent of its name.',
    empty: 'No labels.',
    selectScope: 'Category',
    freeLabel: 'No category',
    valuePlaceholder: 'Type or pick a value…',
    hint: 'Pick a category and a value. You can create a new value if allowed.',
  },
  catalog: {
    pageTitle: 'Label catalog',
    pageDescription: 'Create categories and values to tag devices, independent of the device name.',
    scopes: 'Categories',
    newScope: 'New category',
    editScope: 'Edit category',
    freeLabels: 'Uncategorised labels',
    freeLabelsHint: 'Free labels, with no key.',
    valuesHint: 'Values in this category (e.g. XS-100).',
    noValues: 'No values yet.',
    newValuePlaceholder: 'New value…',
    exclusiveShort: 'single',
    confirmDeleteScope: 'Delete the category "%{key}" and all its values and assignments?',
  },
  fields: {
    key: 'Key',
    displayName: 'Display name',
    color: 'Colour',
    exclusive: 'Single value per device',
  },
  hints: {
    key: 'The key cannot be changed later (e.g. model, locks).',
  },
  owner: {
    global: 'Global (all groups)',
    group: 'A group',
  },
  errors: {
    loadFailed: 'Could not load the labels.',
    assignFailed: 'Could not assign the label.',
    createFailed: 'Could not create the label.',
    removeFailed: 'Could not remove the label.',
    deleteFailed: 'Could not delete.',
  },
};

export default labels;
